import {UseDialogStateReturn} from '@/hooks/useDialogState';
import ConversationForm from '../conversation-form';
import {useContext, useMemo} from 'react';
import {ConversationContext} from '../types';
import {EditDialog} from '@/components/refinedev/dialogs/edit-dialog';
import {ConversationMemberArrayInput} from './conversation-members-dialog';

export const EditConversationDialog = ({dialogState}: {dialogState: UseDialogStateReturn}) => {
  const id = useMemo(() => dialogState?.extraData?.id, [dialogState]);
  const {refetchConversations} = useContext(ConversationContext);
  // if (!id) return null; //

  return (
    <EditDialog
      dialogState={dialogState}
      resource="conversations"
      id={id}
      title="Chỉnh sửa cuộc trao đổi"
      transformBeforeSave={ConversationForm.transformBeforeSave}
      formProps={{
        refineCoreProps: {
          onMutationSuccess: refetchConversations,
          meta: {
            with: ['members'],
          },
        },
      }}>
      <div className="flex flex-col gap-4">
        <span>ID: {id}</span>
        <ConversationForm.GeneralInfo />
        <ConversationMemberArrayInput source="members" />
      </div>
    </EditDialog>
  );
};
